import React from 'react';
import styles from './Modal.css';

const Modal = ({ title, children, id = 'kybInfo' }) => {
  return (
    <div className={`modal fade ${styles.modal}`} id={id} role="dialog">
      <div className={`modal-dialog ${styles['modal-size']}`}>
        <div className="modal-content">
          <div className={`modal-header ${styles['modal-header']}`}>
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <h4 className={`modal-title ${styles['modal-title']}`}>{title}</h4>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
